// src/helpers/lookupMaps.ts

/**
 * These maps MUST match the pricing/bundle tables exactly.
 * Keys are daily grams on a 50g grid.
 * Values are:
 *  - PACK_SIZE_* : chosen pack size (grams)
 *  - TOTAL_PACKS_* : total packs for that plan
 */

export const PACK_SIZE_7_DAY: Record<number, number> = {
  50: 250,
  100: 250,
  150: 250,
  200: 400,
  250: 600,
  300: 600,
  350: 800,
  400: 800,
  450: 800,
  500: 800,
  550: 800,
  600: 800,
  650: 800,
  700: 800,
  750: 800,
  800: 800,
  850: 800,
  900: 800,
  950: 800,
  1000: 800,
  1050: 800,
  1100: 800,
  1150: 800,
  1200: 800,
  1250: 800,
  1300: 800,
  1350: 800,
  1400: 800,
  1450: 800,
  1500: 800,
  1550: 800,
  1600: 800,
  1650: 800,
  1700: 800,
  1750: 800,
  1800: 800,
  1850: 800,
  1900: 800,
  1950: 800,
  2000: 800,
};

export const TOTAL_PACKS_7_DAY: Record<number, number> = {
  50: 2,
  100: 3,
  150: 5,
  200: 4,
  250: 3,
  300: 4,
  350: 4,
  400: 4,
  450: 4,
  500: 5,
  550: 5,
  600: 6,
  650: 6,
  700: 7,
  750: 7,
  800: 7,
  850: 8,
  900: 8,
  950: 9,
  1000: 9,
  1050: 9,
  1100: 9,
  1150: 11,
  1200: 11,
  1250: 11,
  1300: 12,
  1350: 12,
  1400: 13,
  1450: 13,
  1500: 14,
  1550: 14,
  1600: 14,
  1650: 15,
  1700: 15,
  1750: 16,
  1800: 16,
  1850: 17,
  1900: 17,
  1950: 18,
  2000: 18,
};

export const PACK_SIZE_14_DAY: Record<number, number> = {
  50: 250,
  100: 250,
  150: 250,
  200: 400,
  250: 600,
  300: 600,
  350: 800,
  400: 800,
  450: 800,
  500: 800,
  550: 800,
  600: 800,
  650: 800,
  700: 800,
  750: 800,
  800: 800,
  850: 800,
  900: 800,
  950: 800,
  1000: 800,
  1050: 800,
  1100: 800,
  1150: 800,
  1200: 800,
  1250: 800,
  1300: 800,
  1350: 800,
  1400: 800,
  1450: 800,
  1500: 800,
  1550: 800,
  1600: 800,
  1650: 800,
  1700: 800,
  1750: 800,
  1800: 800,
  1850: 800,
  1900: 800,
  1950: 800,
  2000: 800,
};

export const TOTAL_PACKS_14_DAY: Record<number, number> = {
  50: 3,
  100: 6,
  150: 9,
  200: 7,
  250: 6,
  300: 7,
  350: 7,
  400: 8,
  450: 8,
  500: 9,
  550: 10,
  600: 11,
  650: 12,
  700: 13,
  750: 14,
  800: 14,
  850: 15,
  900: 16,
  950: 17,
  1000: 18,
  1050: 19,
  1100: 20,
  1150: 21,
  1200: 21,
  1250: 22,
  1300: 23,
  1350: 24,
  1400: 25,
  1450: 26,
  1500: 27,
  1550: 28,
  1600: 28,
  1650: 29,
  1700: 30,
  1750: 31,
  1800: 32,
  1850: 33,
  1900: 34,
  1950: 35,
  2000: 35,
};

export const PACK_SIZE_28_DAY: Record<number, number> = {
  50: 250,
  100: 250,
  150: 250,
  200: 400,
  250: 600,
  300: 600,
  350: 800,
  400: 800,
  450: 800,
  500: 800,
  550: 800,
  600: 800,
  650: 800,
  700: 800,
  750: 800,
  800: 800,
  850: 800,
  900: 800,
  950: 800,
  1000: 800,
  1050: 800,
  1100: 800,
  1150: 800,
  1200: 800,
  1250: 800,
  1300: 800,
  1350: 800,
  1400: 800,
  1450: 800,
  1500: 800,
  1550: 800,
  1600: 800,
  1650: 800,
  1700: 800,
  1750: 800,
  1800: 800,
  1850: 800,
  1900: 800,
  1950: 800,
  2000: 800,
};

export const TOTAL_PACKS_28_DAY: Record<number, number> = {
  50: 6,
  100: 12,
  150: 17,
  200: 14,
  250: 12,
  300: 14,
  350: 13,
  400: 14,
  450: 16,
  500: 18,
  550: 20,
  600: 21,
  650: 23,
  700: 25,
  750: 27,
  800: 28,
  850: 30,
  900: 32,
  950: 34,
  1000: 35,
  1050: 37,
  1100: 39,
  1150: 41,
  1200: 42,
  1250: 44,
  1300: 46,
  1350: 48,
  1400: 49,
  1450: 51,
  1500: 53,
  1550: 55,
  1600: 56,
  1650: 58,
  1700: 60,
  1750: 62,
  1800: 63,
  1850: 65,
  1900: 67,
  1950: 69,
  2000: 70,
};